import enAU from "date-fns/locale/en-AU/index.js";
import { formatInTimeZone } from "date-fns-tz";
export const format = (date, formatString = "dd MM yyyy") => {
    try {
        return formatInTimeZone(typeof date === "string" ? new Date(date) : date, "Australia/Melbourne", formatString, {
            locale: enAU,
        });
    }
    catch (_) {
        return "n/a";
    }
};
